import submenuView from './submenu/submenu-view'

export default submenuView
